import React, { useEffect, useState } from "react";
import Sidebar from "../Components/Sidebar";
import { Viewer, SpecialZoomLevel } from "@react-pdf-viewer/core";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/highlight/lib/styles/index.css";


const Home = () => {
    const [chat, setChat] = useState([]);
    const [audio, setAudio] = useState([]);
    const [activePdf, setActivePdf] = useState({ name: "NilkanthCharitra-eng.pdf", page: 5, line: 1 });
    const [pdfViewer, setPdfViewer] = useState(false);

    let audioIndex = 0;
    useEffect(() => {
        if (localStorage.getItem("narayanGPT") != null) {
            setChat(JSON.parse(localStorage.getItem("narayanGPT")));
        } else {
            localStorage.setItem("narayanGPT", JSON.stringify(chat));
        }
    }, []);

    const generate = async (context, question, tempSources) => {
        let controller = null;
        const inputMsg = document.getElementById("inputMsg");
        const generateBtn = document.getElementById("generateBtn");
        const stopBtn = document.getElementById("stopBtn");
        setChat([...chat, { role: "user", content: question }, { role: "assistant", content: "Generating..." }]);

        inputMsg.disabled = true;
        generateBtn.disabled = true;
        stopBtn.disabled = false;

        controller = new AbortController();
        const signal = controller.signal;
        let mainContent = "";
        try {
            const response = await fetch(process.env.REACT_APP_SERVER + "/api/gpt", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    messages: [
                        { role: "system", content: "You are Sadhu Gyanjivandas, a holy saint of the Swaminarayan Sampraday. You possess deep knowledge of all the scriptures and the rich history of the Swaminarayan tradition. Answer all questions with this expertise using the given context and no need to introduce yourself all the times." },
                        { role: "user", content: "Context:\n" + context + "\n\nQuestion:\n" + question },
                    ],
                }),
                signal,
            });
            const reader = response.body.getReader();
            const decoder = new TextDecoder("utf-8");

            while (true) {
                const { done, value } = await reader.read();
                if (done) {
                    // var formdata = new FormData();
                    // formdata.append("answer", resultText.innerText);

                    // var requestOptions = {
                    //     method: "POST",
                    //     body: formdata,
                    //     redirect: "follow",
                    // };

                    // fetch(process.env.REACT_APP_SERVER + "/api/audioGenerate", requestOptions)
                    //     .then((response) => response.json())
                    //     .then((result) => {
                    //         setAudio(result.audio);
                    //         document.getElementById("speakMsg").src = "data:audio/mpeg;base64," + result.audio[0];
                    //         audioIndex = 1;
                    //         document.getElementById("speakMsg").play();
                    //         document.getElementById("speakMsg").addEventListener(
                    //             "ended",
                    //             () => {
                    //                 try {
                    //                     document.getElementById("speakMsg").pause();
                    //                     console.log("ended");
                    //                     if (audioIndex < result.audio.length) {
                    //                         document.getElementById("speakMsg").src = "data:audio/mpeg;base64," + result.audio[audioIndex];
                    //                         document.getElementById("speakMsg").play();
                    //                         audioIndex += 1;
                    //                     } else {
                    //                         document.getElementById("speakMsg").src = "";
                    //                         audioIndex = 0;
                    //                         setAudio([]);
                    //                     }
                    //                 } catch {}
                    //             },
                    //             false
                    //         );
                    //     })
                    //     .catch((error) => console.log("error", error));
                    break;
                }

                const chunk = decoder.decode(value);
                for (const line of chunk.split("data: ")) {
                    if (line.trim() !== "" && line.trim() !== "[DONE]") {
                        let content = null;
                        try {
                            content = JSON.parse(line.trim());
                            if (content) {
                                if (content["choices"][0]["delta"]["content"] !== undefined) {
                                    mainContent = mainContent + content["choices"][0]["delta"]["content"];
                                    console.log(mainContent);
                                    setChat([...chat, { role: "user", content: question }, { role: "assistant", content: mainContent, sources: tempSources }]);
                                    document.getElementById("chatContainer").scrollTop = document.getElementById("chatContainer").scrollHeight;
                                }
                            }
                        } catch (e) {}
                    }
                }
            }
        } catch (error) {
            if (signal.aborted) {
                setChat([...chat, { role: "user", content: question }, { role: "assistant", content: "Request aborted." }]);
            } else {
                console.error("Error:", error);
                setChat([...chat, { role: "user", content: question }, { role: "assistant", content: "Error occurred while generating." }]);
            }
        } finally {
            inputMsg.disabled = false;
            generateBtn.disabled = false;
            stopBtn.disabled = true;
            controller = null;
            let tempChat = JSON.parse(localStorage.getItem("narayanGPT"));
            localStorage.setItem("narayanGPT", JSON.stringify([...tempChat, { role: "assistant", content: mainContent, sources: tempSources }]));
        }
    };
    return (
        <div className="flex flex-nowrap h-screen">
            <Sidebar />
            <div className="h-full w-full lg:w-[80%] relative">
                <audio id="speakMsg" controls className="hidden">
                    {/* {audio.map((item, index) => (
                        <source key={index} src={"data:audio/mpeg;base64," + item} type="audio/mpeg" />
                    ))} */}
                    <source src="" type="audio/mpeg" />
                </audio>
                {pdfViewer && (
                    <div className="bg-black/25 w-full h-full absolute top-0 left-0 z-50 lg:px-[20%]">
                        <svg
                            onClick={() => {
                                setPdfViewer(!pdfViewer);
                            }}
                            width={40}
                            height={40}
                            viewBox="0 0 16 16"
                            className="absolute top-5 right-5 cursor-pointer bg-red-500 text-white shadow-xl border-2 border-red-900 rounded-full p-1"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path fillRule="evenodd" fill="currentColor" d="M11.293 3.293a1 1 0 1 1 1.414 1.414L9.414 8l3.293 3.293a1 1 0 0 1-1.414 1.414L8 9.414l-3.293 3.293a1 1 0 0 1-1.414-1.414L6.586 8 3.293 4.707a1 1 0 0 1 1.414-1.414L8 6.586z" />
                        </svg>

                        {/* <Viewer defaultScale={SpecialZoomLevel.PageFit} fileUrl={process.env.REACT_APP_SERVER + "/static/pdfs/" + activePdf?.name} initialPage={activePdf?.page} /> */}
                        <Viewer defaultScale={SpecialZoomLevel.PageFit} fileUrl={"https://huggingface.co/spaces/thejagstudio/narayangpt/resolve/main/static/pdfs/" + activePdf?.name} initialPage={activePdf?.page} />
                    </div>
                )}
                <div id="chatContainer" className="w-full h-[calc(100vh-4.5rem)] overflow-y-scroll noScroolbar p-10 relative flex flex-col gap-2 scroll-smooth">
                    {chat.map((msg, index) => {
                        if (msg?.role === "user") {
                            return (
                                <div key={index} className="min-w-full w-full h-fit relative">
                                    <div className="bg-primary-500 w-fit max-w-[70%] h-fit ml-auto rounded-l-xl rounded-tr-xl rounded-br-sm p-2 text-white shadow-xl">
                                        <p>{msg["content"]}</p>
                                    </div>
                                </div>
                            );
                        } else if (msg?.role === "assistant") {
                            return (
                                <div key={index} className="min-w-full w-full h-fit relative">
                                    <div className="bg-white w-fit max-w-[70%] h-fit  rounded-r-xl rounded-tl-xl rounded-bl-sm p-2 text-primary-600 shadow-xl">
                                        <p className="whitespace-pre-line">{msg["content"]}</p>
                                    </div>
                                    <div className="flex flex-nowrap items-center justify-start w-[70%] gap-3 z-10 mt-3">
                                        {msg?.sources?.map((source, index) => {
                                            let pdf = source.replace("pdfs\\", "").split(":")[0];
                                            let page = source.split(":")[1];
                                            let line = source.split(":")[2];

                                            return (
                                                <div
                                                    onClick={() => {
                                                        setActivePdf({ name: pdf, page: page, line: line });
                                                        setPdfViewer(true);
                                                    }}
                                                    key={index}
                                                    title={pdf}
                                                    className="bg-white text-blue-500 italic text-sm hover:bg-blue-500 hover:text-white cursor-pointer rounded-full shadow-inner transition-all py-1 px-4 h-fit w-[20%] truncate "
                                                >
                                                    {index + 1}. {pdf}
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        } else {
                            return (
                                <div key={index} className="min-w-full w-full h-fit relative">
                                    <div className="bg-white w-fit max-w-[70%] h-fit  rounded-r-xl rounded-tl-xl rounded-bl-sm p-2 text-red-500 shadow-xl">
                                        <p>There is some Error. Sorry for the inconvenience</p>
                                    </div>
                                </div>
                            );
                        }
                    })}
                </div>
                <div className="w-full h-[4.5rem] flex flex-col items-center justify-center ">
                    <div className="w-[80%] h-12 relative">
                        <input
                            onKeyUp={(event) => {
                                if (event.code === "Enter" || event.code === "NumpadEnter") {
                                    let chatContainer = document.getElementById("chatContainer");
                                    let msg = document.getElementById("inputMsg").value;
                                    if (msg !== "") {
                                        let tempChat = JSON.parse(localStorage.getItem("narayanGPT"));
                                        localStorage.setItem("narayanGPT", JSON.stringify([...tempChat, { role: "user", content: msg }]));
                                    }
                                    chatContainer.scrollTop = chatContainer.scrollHeight;
                                    var formdata = new FormData();
                                    formdata.append("question", msg);

                                    var requestOptions = {
                                        method: "POST",
                                        body: formdata,
                                        redirect: "follow",
                                    };
                                    fetch(process.env.REACT_APP_SERVER + "/api/getContext", requestOptions)
                                        .then((response) => response.json())
                                        .then((result) => {
                                            document.getElementById("inputMsg").value = "";
                                            generate(result.context, msg, result.sources);
                                        })
                                        .catch((error) => console.log("error", error));
                                }
                            }}
                            className="w-full h-full rounded-lg shadow-lg pl-3 pr-10 focus:outline-none"
                            placeholder="Type your query ..."
                            type="text"
                            id="inputMsg"
                            name=""
                        />
                        <div className="absolute top-1.5 right-2 flex gap-1">
                            <button
                                onClick={(event) => {
                                    let chatContainer = document.getElementById("chatContainer");
                                    let msg = document.getElementById("inputMsg").value;
                                    if (msg !== "") {
                                        let tempChat = JSON.parse(localStorage.getItem("narayanGPT"));
                                        localStorage.setItem("narayanGPT", JSON.stringify([...tempChat, { role: "user", content: msg }]));
                                    }
                                    chatContainer.scrollTop = chatContainer.scrollHeight;
                                    var formdata = new FormData();
                                    formdata.append("question", msg);

                                    var requestOptions = {
                                        method: "POST",
                                        body: formdata,
                                        redirect: "follow",
                                    };
                                    fetch(process.env.REACT_APP_SERVER + "/api/getContext", requestOptions)
                                        .then((response) => response.json())
                                        .then((result) => {
                                            document.getElementById("inputMsg").value = "";
                                            generate(result.context, msg, result.sources);
                                        })
                                        .catch((error) => console.log("error", error));
                                }}
                                id="generateBtn"
                                className=" disabled:hidden"
                            >
                                <svg className="bg-primary-500 rounded-lg p-1" width={35} height={35} viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.79 2.772 24.86 12.85a1.25 1.25 0 0 1 0 2.255L3.79 25.183a1.25 1.25 0 0 1-1.746-1.457l2.108-7.728a.5.5 0 0 1 .415-.364l10.21-1.387a.25.25 0 0 0 .195-.149l.018-.063a.25.25 0 0 0-.157-.268l-.055-.014-10.2-1.387a.5.5 0 0 1-.414-.364l-2.12-7.773A1.25 1.25 0 0 1 3.79 2.772Z" fill="white" />
                                </svg>
                            </button>
                            <button id="stopBtn" disabled className=" disabled:hidden">
                                <svg fill="white" className="bg-primary-500 rounded-lg p-1" xmlns="http://www.w3.org/2000/svg" width={35} height={35} viewBox="0 0 512 512" xmlSpace="preserve">
                                    <path d="M256 0C114.609 0 0 114.609 0 256s114.609 256 256 256 256-114.609 256-256S397.391 0 256 0zm0 472c-119.297 0-216-96.703-216-216S136.703 40 256 40s216 96.703 216 216-96.703 216-216 216z" />
                                    <path d="M176 176h160v160H176z" />
                                </svg>
                            </button>
                            <button
                                onClick={() => {
                                    localStorage.setItem("narayanGPT", JSON.stringify([]));
                                    document.getElementById("inputMsg").value = "";
                                    setChat([]);
                                }}
                            >
                                <svg className="bg-primary-500 rounded-lg p-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" xmlSpace="preserve" width={35} height={35}>
                                    <path
                                        d="M14 17V3c0-1.1.9-2 2-2h0c1.1 0 2 .9 2 2v14m-4-3h4m8 17H6l2.7-12.4c.2-.9 1-1.6 2-1.6h10.8c.9 0 1.8.7 2 1.6L26 31zM9 21h14m-12 6v3m10-1v1"
                                        style={{
                                            fill: "none",
                                            stroke: "#fff",
                                            strokeWidth: 2,
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            strokeMiterlimit: 10,
                                        }}
                                    />
                                </svg>
                            </button>
                        </div>
                    </div>
                    <div className="text-slate-600 ">
                        NarayanGPT Developed by <span className="font-bold text-slate-800">Jagrat Patel</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
